import Chat from '@commons/chats'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
const CustomerSupport = () => {
  return <Chat />
}

export default CustomerSupport
